export async function getCroppedImg(imageSrc, pixelCrop, pageNumber) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  
  // Set canvas dimensions to the cropped area
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  
  // Draw the cropped portion of the image on the canvas
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );
  
  // Return the canvas data as a base64 string
  return canvas.toDataURL('image/jpeg');
}

function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.src = url;
  });
}
